import { render, staticRenderFns } from "./MentorSelect.vue?vue&type=template&id=5db4cc3d"
import script from "./MentorSelect.vue?vue&type=script&lang=ts"
export * from "./MentorSelect.vue?vue&type=script&lang=ts"
import style0 from "./MentorSelect.vue?vue&type=style&index=0&id=5db4cc3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports